import React, { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import applicationComander from "../../../store/commanders/application.comander";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useSelector } from "react-redux";
import { faLongArrowAltLeft } from "@fortawesome/free-solid-svg-icons";

import {
  Box,
  Button,
  Group,
  List,
  Space,
  Text,
  TextInput,
} from "@mantine/core";
import { useForm } from "@mantine/form";
import { URL_PATHS } from "../../../consts/url.paths.consts";
import { Icon } from "@fortawesome/fontawesome-svg-core";
import { Redirect } from "react-router-dom";
import { useTranslation } from "react-i18next";

const ChangePasswordPage = (props) => {
  const { t } = useTranslation();
  const history = useHistory();
  const appState = useSelector((state: any) => state.application);

  const tempSession = useSelector(
    (state: any) => state.application.tempSession
  );

  const onSubmit = (data) =>
    applicationComander.cmd_new_password(data.new_password, tempSession);

  const form = useForm({
    initialValues: {
      new_password: "",
    },
  });

  if (!appState.authorise) {
    return (
      <div>
        <div className="auth-container-box">
          <Box className="auth-single-form">
            <Text className="auth-title">{t("auth.newPasswordFlow.title")}</Text>
            <Text className="auth-description">
              {t("auth.newPasswordFlow.description")}
            </Text>
            <form
              onSubmit={form.onSubmit((values) => onSubmit(values))}
              className="u-w-100"
            >
              <List size="xs" mt={"lg"} px={"md"} spacing={-2}>
                {t("auth.passwordRules")}
                <List.Item>{t("auth.passwordRuleLength")}</List.Item>
                <List.Item>{t("auth.passwordRuleUppercase")}</List.Item>
                <List.Item>{t("auth.passwordRuleLowercase")}</List.Item>
                <List.Item>{t("auth.passwordRuleNumber")}</List.Item>
              </List>

              <Space h="md" />
              <TextInput
                required
                autoComplete="new-password"
                label={t("auth.newPassword")}
                placeholder={t("auth.newPasswordPlaceholder")}
                className="u-w-100"
                {...form.getInputProps("new_password")}
                type="password"
              />

              <Group mt="lg" mb="sm">
                <Button
                  size="lg"
                  type="submit"
                  className="u-w-100 auth-submit-button"
                >
                  {t("auth.newPasswordFlow.submit")}
                </Button>
                <Button
                  size="lg"
                  variant="outline"
                  className="u-w-100 mobile-auth-button"
                  onClick={() => history.push(URL_PATHS.LOGIN)}
                >
                  {t("auth.backToLogin")}
                </Button>
              </Group>

              <Text
                component="button"
                type="button"
                size="sm"
                align="left"
                className="auth-link"
                onClick={() => history.push(URL_PATHS.LOGIN)}
              >
                <FontAwesomeIcon icon={faLongArrowAltLeft as Icon} /> {t("auth.backToLogin")}
              </Text>
            </form>
          </Box>
        </div>
      </div>
    );
  } else {
    return <Redirect to={URL_PATHS.APP} />;
  }
};

export default ChangePasswordPage;
